import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { PermissionBasedAccessDirective } from '../../../directives/permission-based-access.directive'
import { TranslateModule } from '@ngx-translate/core'

export interface MainNavBarMenuItem {
  text: string
  icon: string
  routerLink?: string
  permissionsNeeded: string[]
  subitems?: MainNavBarMenuSubitem[]
}

export interface MainNavBarMenuSubitem {
  text: string
  icon: string
  routerLink?: string
  permissionsNeeded: string[]
  subitems?: MainNavBarMenuSubitem[]
}

@Component({
    selector: 'sarbo-main-nav-bar-menu',
    imports: [CommonModule, RouterModule, PermissionBasedAccessDirective, TranslateModule],
    templateUrl: './main-nav-bar-menu.component.html',
    styleUrl: './main-nav-bar-menu.component.scss'
})
export class MainNavBarMenuComponent {
  @Input() menuItems: MainNavBarMenuItem[]
  @Input() selectedMenuItem: string
  selectedNestedMenuItem: string
  @Output() selectedMenuSubitem = new EventEmitter<MainNavBarMenuSubitem>()

  toggleMenuItem(menuItemText: string): void {
    this.selectedMenuItem = this.selectedMenuItem === menuItemText ? '' : menuItemText
    this.selectedNestedMenuItem = ''
  }

  toggleNestedMenuItem(menuSubitemText: string): void {
    this.selectedNestedMenuItem = this.selectedNestedMenuItem === menuSubitemText ? '' : menuSubitemText
  }
}
